import {
  FXPRO_CORPORATE_URL,
  FXPRO_OFFICIAL_PARTNER_URL,
  ICMARKETS_CORPORATE_URL,
  getIcMarketsPartnerUrl,
} from "constants/brokerPartners";

/**
 * Plain-text lines for broker refund notice (Refund Policy page + Sign-up modal).
 * No hyperlinks — URLs only. Keep in sync with `constants/brokerPartners`.
 */
export function getBrokerPartnerRefundSignupParagraphs() {
  const icPartner = getIcMarketsPartnerUrl();
  const lines = [
    "Broker partner requirement for refunds: To be eligible for a refund under our first-month satisfaction guarantee, you must register, fund, and trade using an AlphaSniper designated broker partner account, in line with the official partner links and onboarding instructions we provide. Accounts opened with non-partner brokers, or outside the designated partner programme, are not eligible for refund consideration under that guarantee.",
    "Links for verification:",
    `FxPro — official AlphaSniper partner onboarding: ${FXPRO_OFFICIAL_PARTNER_URL}`,
    icPartner
      ? `IC Markets — official AlphaSniper partner onboarding: ${icPartner}`
      : "IC Markets — official partner onboarding: use the link supplied in your AlphaSniper onboarding, or see the How it works page on this website.",
    `FxPro — corporate website: ${FXPRO_CORPORATE_URL}`,
    `IC Markets — corporate website: ${ICMARKETS_CORPORATE_URL}`,
    "Full guarantee rules: see the Refund Policy page on this website (/RefundPolicy).",
  ];
  return lines;
}
